import { render, staticRenderFns } from "./KeycloakProvider.vue?vue&type=template&id=c5fcc10c&scoped=true&"
import script from "./KeycloakProvider.vue?vue&type=script&lang=js&"
export * from "./KeycloakProvider.vue?vue&type=script&lang=js&"
import style0 from "./KeycloakProvider.vue?vue&type=style&index=0&id=c5fcc10c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fcc10c",
  null
  
)

export default component.exports